import { useEffect } from 'react'

const MANROPE_HREF =
  'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap'

/**
 * Loads the Manrope webfont on demand. The app ships with the OS system font
 * stack, but surfaces that mirror signater.com's marketing type (the public
 * badge, the auth brand panel) use Manrope. The <link> is appended on mount
 * and removed on unmount, so no other route pays for the font.
 *
 * The duplicate guard is first-mount-wins: consumers never co-mount today, so
 * refcounting would be dead complexity.
 *
 * Production hardening (out of scope here): self-host via
 * `@fontsource-variable/manrope` to drop the external request and avoid FOUT.
 */
export function useManropeFont() {
  useEffect(() => {
    if (document.head.querySelector('link[data-manrope-font]')) return

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = MANROPE_HREF
    link.setAttribute('data-manrope-font', '')
    document.head.appendChild(link)

    return () => {
      link.remove()
    }
  }, [])
}
